module.exports = __webpack_public_path__ + "static/media/wa.02bd2aad.svg";